import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import React from 'react'
import SaleContactCreditDialog from '../../dialogs/credits/SaleContactCreditDialog';
import SaleContactCreditViewDialog from '../../dialogs/credits/SaleContactCreditViewDialog';
import { SaleContactRemovalButton } from '../buttons/SaleContactButtons';
import { AgTechContact } from '@agtech/data/contacts/ContactData';
import ContactDialog from '@agtech/web/integrations/contacts/dialogs/ContactDialog';
import ContactNoteDialog from '@agtech/web/integrations/contacts/dialogs/notes/ContactNoteDialog';
import ContactNotesViewDialog from '@agtech/web/integrations/contacts/dialogs/notes/ContactNoteViewDialog';

export type SaleContactActionMenuProps = {
    contact: AgTechContact
}

const SaleContactActionMenu = (props: SaleContactActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Contact">
                <ContactDialog.Button contactId={props.contact.id} />
                <SaleContactRemovalButton contact={props.contact} />
            </AgTechVerticalPopUpMenuSection>
            <AgTechVerticalPopUpMenuSection header="Notes">
                <ContactNoteDialog.Button contactId={props.contact.id} />
                <ContactNotesViewDialog.Button contactId={props.contact.id} />
            </AgTechVerticalPopUpMenuSection>
            <AgTechVerticalPopUpMenuSection header="Credits">
                <SaleContactCreditDialog.Button contactId={props.contact.id} />
                <SaleContactCreditViewDialog.Button contactId={props.contact.id} />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
};

export default SaleContactActionMenu;